import {axiosInstance} from "@/plugins/axios";

export interface ProductDeterminationErrorPayload {
    start_application_date: string,
    end_application_date: string,
    id_item: number
}

export async function getDeterminationErrorsByItem(payload: ProductDeterminationErrorPayload) {
    let url = 'product_determination_errors?';
    
    if (payload.start_application_date && payload.end_application_date) {
        url += `start_application_date=${payload.start_application_date}&end_application_date=${payload.end_application_date}&`;
    }

    if(payload.id_item) {
        url += `id_item=${payload.id_item}`;
    }

    const response = await axiosInstance.get(url);
    return response.data;
}